import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import Newsletter from "../components/Newsletter";
import ServiceInnerDetails from "../components/ServiceInnerDetails";

const ServiceHunting = () => {
  let [active, setActive] = useState(true);
  useEffect(() => { setTimeout(function () { setActive(false); }, 500); }, []);
  return (
    <>
      <HelmetReact title={"Hunting de Profissionais"} />
      <HeaderTwo />
      <Breadcrumb title="Hunting de Profissionais" />
      <ServiceInnerDetails serviceId="hunting" />
      <FooterTwo />
    </>
  );
};
export default ServiceHunting;